let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("2hmUs"), load("bCeK4"), load("l1KCV")]).then(() => parcelRequire('1g8fI'));